<template>
  <v-layout row wrap ma-0 mt-4 align-end class="d-flex align-center">
    <v-dialog v-model="dialog" persistent min-width="650px" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn rounded outlined color="primary" min-width="120px" v-on="on">{{ title }}</v-btn>
        <div
          v-if="carsLength !== 0"
          class="d-flex justify-center align-center primary white--text length-number ml-2"
        >
          {{ carsLength }}
        </div>
      </template>

      <!-- dialog -->
      <v-card>
        <v-card-title class="v-card-title">
          <span class="subtitle-1">รายละเอียดผู้ใช้ทาง</span>
          <v-icon color="#BA4438" @click="dialog = false">close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-expansion-panels multiple>
              <v-expansion-panel v-for="(car, i) in cars" :key="i">
                <v-expansion-panel-header expand-icon="mdi-menu-down" flex>
                  <v-icon style="display: contents;" color="#BA4438" @click="removeAccident(i)"
                    >highlight_off</v-icon
                  >

                  <span class="ml-2 car-type">{{ getCarListsName(car) }}</span>

                  <span class="ml-2" v-if="i != 0">{{ i + 1 }}</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-layout row wrap ma-0>
                    <v-flex
                      v-for="(form, j) in formItems"
                      :key="j"
                      xs6
                      :class="[j % 2 == 0 ? 'pr-3' : 'pl-3']"
                      align-self-start
                      v-show="car.type !== notVehicleId || form.isVehicleInfo !== true"
                    >
                      <p class="font-weight-medium mb-0 pt-4">{{ form.title }}</p>
                      <v-layout row wrap ma-0 v-if="form.key == 'plate'">
                        <v-flex xs3>
                          <v-text-field
                            v-model="car['plate1']"
                            :label="form.label.split(' ').shift()"
                            class="card-border"
                            flat
                            solo
                            hide-details
                            maxlength="3"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs1 class="mt-4 text-center">
                          <span>-</span>
                        </v-flex>
                        <v-flex xs8>
                          <v-text-field
                            v-model="car['plate2']"
                            :label="form.label.split(' ').pop()"
                            class="card-border"
                            flat
                            solo
                            hide-details
                            maxlength="4"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-select
                        v-else-if="form.items"
                        v-model="car[form.key]"
                        :items="form.items"
                        label="เลือก"
                        no-data-text="ไม่พบข้อมูล"
                        class="card-border"
                        item-text="name"
                        item-value="id"
                        flat
                        solo
                        hide-details
                        @change="
                          logs(car);
                          initCarsValue(car);
                        "
                      ></v-select>
                      <v-text-field
                        v-else
                        v-model="car[form.key]"
                        :label="form.label"
                        class="card-border"
                        flat
                        solo
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <div v-for="(user, k) in car.users" :key="k">
                    <v-layout row wrap ma-0 mt-4>
                      <p class="font-weight-medium mb-0 pt-4">
                        ชื่อผู้โดยสาร
                        <span class="ml-0" v-if="k != 0">{{ k + 1 }}</span>
                      </p>
                    </v-layout>

                    <v-layout row wrap ma-0>
                      <v-flex xs9 pr-3 class="name">
                        <v-icon
                          class="pr-3"
                          color="#BA4438"
                          @click="removeUser(i, k)"
                          v-if="car.users.length > 1"
                          >remove_circle</v-icon
                        >

                        <v-text-field
                          v-model="user.name"
                          label="ชื่อ - นามสกุล"
                          class="card-border"
                          flat
                          solo
                          hide-details
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs3 class="d-flex align-center pl-3">
                        <v-btn
                          v-if="k == 0"
                          rounded
                          outlined
                          color="primary"
                          min-width="120px"
                          @click="createUser(car)"
                        >
                          <v-icon>add_circle</v-icon>&nbsp;เพิ่มผู้โดยสาร
                        </v-btn>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap ma-0 mt-2>
                      <v-flex xs6 pr-3>
                        <p class="font-weight-medium mb-0">
                          {{ `ข้อมูลบัตรประชาชน ${isShowAsterisk ? '*' : ''} ` }}
                        </p>
                        <v-text-field
                          v-model="user.id"
                          class="card-border"
                          label="เลขบัตรประชาชน"
                          flat
                          solo
                          hide-details
                          maxlength="13"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs3 px-3>
                        <p class="font-weight-medium mb-0">
                          {{ `เพศ ${isShowAsterisk ? '*' : ''} ` }}
                        </p>
                        <v-select
                          v-model="user.gender"
                          :items="sexListItem"
                          label="เลือก"
                          no-data-text="ไม่พบข้อมูล"
                          item-text="name"
                          item-value="id"
                          class="card-border"
                          flat
                          solo
                          hide-details
                        ></v-select>
                      </v-flex>

                      <v-flex xs3 pl-3>
                        <p class="font-weight-medium mb-0">
                          {{ `อายุ ${isShowAsterisk ? '*' : ''} ` }}
                        </p>
                        <v-text-field
                          v-model="user.age"
                          label="อายุ"
                          class="card-border"
                          flat
                          solo
                          hide-details
                          type="number"
                          min="1"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
        </v-card-text>
        <v-card-actions style="padding: 16px; padding-top: 0;">
          <v-flex
            class="d-flex flex-column flex-sm-row align-end mt-10 mt-sm-0"
            :class="{ 'height-200': $vuetify.breakpoint.smAndUp }"
          >
            <v-spacer></v-spacer>
            <v-btn
              :block="$vuetify.breakpoint.xsOnly"
              rounded
              outlined
              width="120"
              color="primary"
              class="mt-2"
              @click="createCar"
              >เพิ่ม</v-btn
            >
            <v-btn
              :block="$vuetify.breakpoint.xsOnly"
              rounded
              width="120"
              color="primary"
              class="mt-2 ml-2"
              @click="save"
              >บันทึก</v-btn
            >
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'VehicleFormDialog',
  data: () => ({
    on: false,
    dialog: false,
    //
    damageDrr: '',
    damagePrivate: '',
    //
    formItems: [],
    provinceItems: [],
    licenseItems: [],
    damageReportItems: [],
    //
    accidentProperty: {},
    cars: []
  }),
  props: {
    title: {
      type: String,
      default: ''
    },
    isAddTrain: {
      type: Boolean,
      default: false
    },
    provinceListItem: {
      type: Array
    },
    vehicleListItem: {
      type: Array
    },
    vehicleBrandListItem: {
      type: Array
    },
    sexListItem: {
      type: Array
    },
    notVehicleId: {
      type: String,
      default: ''
    }
  },
  created() {
    this.getLicenseLists();
    this.getForm();
    this.createCar();
  },
  mounted() {},
  methods: {
    setDefaultData(data) {
      this.cars = data || [];
      this.save();
    },
    createUserProperty() {
      return {
        name: null,
        id: null,
        age: null,
        gender: null
        // license: null
      };
    },
    createUser(obj) {
      const user = this.createUserProperty();
      obj.users.push(user);
    },
    removeUser(caridx, idx) {
      if (this.cars[caridx].users.length <= 1) {
        return;
      }

      this.cars[caridx].users.splice(idx, 1);
    },
    createCar() {
      const formProperty = {};
      this.formItems.forEach(item => {
        if (item.key == 'plate') {
          formProperty.plate1 = null;
          formProperty.plate2 = null;
        } else {
          formProperty[item.key] = null;
        }
      });

      const user = this.createUserProperty();
      formProperty.users = [user];

      this.cars.push(formProperty);
    },
    removeAccident(idx) {
      this.cars.splice(idx, 1);
    },
    getLicenseLists() {
      this.licenseItems = [
        { id: '1', name: 'มี' },
        { id: '2', name: 'ไม่มี' },
        { id: '3', name: 'ไม่ระบุ' }
      ];
    },
    getForm() {
      this.formItems.push({
        title: 'ประเภทผู้ใช้ทาง *',
        key: 'type',
        value: '',
        items: this.vehicleListItem,
        isVehicleInfo: false
      });

      if (!this.isAddTrain) {
        this.formItems.push({
          title: 'เป็นสาเหตุหลักของการเกิดอุบัติเหตุ',
          key: 'is_caused',
          value: '',
          items: ['ไม่ใช่', 'ใช่'],
          isVehicleInfo: false
        });
      }

      this.formItems.push({
        title: 'ยี่ห้อของยานพาหนะ',
        key: 'brand',
        value: '',
        items: this.vehicleBrandListItem,
        isVehicleInfo: true
      });

      this.formItems.push({
        title: 'สีของยานพาหนะ',
        key: 'color',
        value: '',
        label: 'ขาว-ดำ',
        isVehicleInfo: true
      });

      this.formItems.push({
        title: 'หมายเลขทะเบียน',
        key: 'plate',
        value: '',
        label: 'ยษ 418',
        isVehicleInfo: true
      });

      this.formItems.push({
        title: `จังหวัด ${this.isShowAsterisk ? '*' : ''}`,
        key: 'province',
        value: '',
        items: this.provinceListItem,
        // items: this.$parent.provinceItems
        isVehicleInfo: true
      });

      this.formItems.push({
        title: `ข้อมูลอนุญาตขับขี่`,
        key: 'license',
        value: '',
        items: this.licenseItems,
        isVehicleInfo: true
      });
    },
    alert() {
      alert('บันทึกเรียบร้อย');
      this.dialog = false;
    },
    close() {
      console.log('Dialog closed');
    },
    logs(value) {
      console.log(value);
      console.log(this.accidentProperty);
      console.log(this.cars);
    },
    save() {
      for (let index = 0; index < this.cars.length; index++) {
        const element = this.cars[index];
        if (element.plate1 && element.plate2) {
          element.plate = `${element.plate1}-${element.plate2}`;
        } else if (element.plate1) {
          element.plate = element.plate1;
        } else if (element.plate2) {
          element.plate = element.plate2;
        } else {
          element.plate = '';
        }
      }
      this.$emit('getVehicleLists', this.cars);
      this.dialog = false;
    },
    getCarListsName(car) {
      const item = this.vehicleListItem.filter(function(u) {
        return u.id == car.type;
      });

      if (item && item.length > 0) return item[0].name;

      return 'ผู้ใช้ทางและยานพาหนะ';
    },
    initCarsValue(car) {
      if (car.type === this.notVehicleId) {
        this.formItems.forEach(form => {
          if (form.isVehicleInfo === true) {
            if (form.key == 'plate') {
              car.plate1 = null;
              car.plate2 = null;
            } else {
              car[form.key] = null;
            }
          }
        });
      }
    }
  },
  computed: {
    isShowAsterisk() {
      return !this.isAddTrain;
    },
    carsLength() {
      return this.cars.length;
    }
  },
  watch: {
    provinceListItem(value) {
      this.formItems = this.formItems.map(item => {
        if (item.key == 'province') {
          item.items = value.slice();
          item.items.unshift({ id: '', name: 'ไม่ระบุ' });
        }
        return item;
      });
    },
    vehicleListItem(value) {
      this.formItems = this.formItems.map(item => {
        if (item.key == 'type') {
          item.items = value.slice();
          item.items.unshift({ id: '', name: 'ไม่ระบุ' });
        }
        return item;
      });
    },
    vehicleBrandListItem(value) {
      this.formItems = this.formItems.map(item => {
        if (item.key == 'brand') {
          item.items = value.slice();
          item.items.unshift({ id: '', name: 'ไม่ระบุ' });
        }
        return item;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  background-color: white;
}

.card-border {
  margin-top: 4px;
}

.v-text-field {
  height: 40px;
}

.headline {
  color: #ba4438;
  border-bottom: 1px solid #ededed;
  p {
    font-size: 18px;
  }
}

.length-number {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.v-card-title {
  border-bottom: 1px solid #cfcfcf;
  justify-content: space-between;
}

.v-card__text {
  padding: 20px !important;
}

.v-expansion-panel {
  margin-bottom: 18px;
  border: 1px solid #cfcfcf;
  border-radius: 5px;
}

.v-expansion-panel-header {
  padding: 5px 10px;
  min-height: 40px !important;
  background: #efefef;
}

.v-expansion-panel-content {
  padding: 10px 0 0 0;
}

.v-text-field {
  height: 40px;
}

.danger-table {
  border: 1px solid #cfcfcf;
  border-radius: 3px;
  width: 100%;
}

.danger-table th {
  margin: 0;
  padding: 5px 0;
  text-align: center;
  height: auto;
}

.danger-table td {
  border: none !important;
  text-align: center !important;
}

.danger-table .v-data-table__wrapper table tbody {
  border-top: 1px solid #cfcfcf !important;
}

.danger-th {
  border-bottom: 1px solid #cfcfcf !important;
}

.car-type {
  display: block;
  max-width: fit-content;
}

.danger-table.theme--light.v-data-table .v-data-table__wrapper tbody tr td {
  border: none !important;
  text-align: center !important;
}

.name {
  display: flex;
}
</style>
